/* eslint import/no-webpack-loader-syntax: off */
import colors from '!!sass-vars-to-js-loader!../../assets/scss/base/_colors.scss';

export default {
	primary: colors.clrPrimary.rgba,
	primarylight: colors.clrPrimaryLight.rgba,
	secondary: colors.clrSecondary.rgba,
	secondaryLight: colors.clrSecondaryLight.rgba,
	whitePrimary: colors.clrWhitePrimary.rgba,
	whiteSecondary: colors.clrWhiteSecondary.rgba,
	black: colors.clrBlack.rgba,
	blackPrimary: colors.clrBlackPrimary.rgba,
	blackSecondary: colors.clrBlackSecondary.rgba
};
